import { render, staticRenderFns } from "./ExpensesLinks.vue?vue&type=template&id=85f8b9ec&scoped=true&"
import script from "./ExpensesLinks.vue?vue&type=script&lang=js&"
export * from "./ExpensesLinks.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesLinks.vue?vue&type=style&index=0&id=85f8b9ec&lang=scss&scoped=true&"
import style1 from "./ExpensesLinks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f8b9ec",
  null
  
)

export default component.exports